exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ntd[data-v-55783f57] {\n    text-align: center;\n    vertical-align: middle;\n}\n", ""]);
